type ProviderIconProps = {
  provider?: string;
};

const getProviderColorClass = (provider: string): string => {
  switch (provider.toLowerCase()) {
    case "openai":
      return "bg-[var(--success)]";
    case "anthropic":
      return "bg-sky-500";
    case "cohere":
      return "bg-[var(--secondary)]";
    case "mistral":
      return "bg-[var(--primary)]";
    case "groq":
      return "bg-[var(--warning)]";
    case "private":
      return "bg-[var(--secondary)]";
    default:
      return "bg-[var(--muted)]";
  }
};

const providerMap: Record<string, string> = {
  openai: "/providers/openai.ico",
  anthropic: "/providers/anthropic.webp",
  cohere: "/providers/cohere.svg",
  mistral: "/providers/mistral.webp",
  groq: "/providers/groq.png",
};

const ProviderIcon = ({ provider = "" }: ProviderIconProps) => {
  const normalizedProvider = provider.toLowerCase();
  const iconPath = providerMap[normalizedProvider];

  if (!iconPath) {
    return (
      <span
        role="img"
        aria-label={provider || "provider"}
        className={`flex size-6 items-center justify-center rounded-full text-xs font-medium text-foreground ${getProviderColorClass(provider)}`}
      >
        {provider.charAt(0).toUpperCase()}
      </span>
    );
  }

  return (
    <span className="flex size-6 items-center justify-center overflow-hidden rounded-full border border-border bg-background">
      <img
        src={iconPath}
        alt={provider}
        className="size-full object-contain"
      />
    </span>
  );
};

export default ProviderIcon;
